import React from 'react'
import { FormComponent } from '../../../components/form/DynamicForm'
import { Form, Validators } from '../../../components/form/DynamicFormTs'
import { withRouter } from "react-router-dom";
import Http from '../../../Http';
import { objectAsParams } from '../../../helpers';

class CalcularKm extends FormComponent {

  componentDidMount() {
    this.FormConfig(
      { defaultUrl: 'zona/one', saveUrl: 'zona/por-colonia', backUrl: false },
      new Form([
        Form.Field('select', 'id_sucursal', 'Sucursal', '', [Validators.required], 6),
        Form.Field('text', 'codigo_postal', 'Codigo Postal', '', [Validators.required], 6),
        Form.Field('select', 'id_colonia', 'Colonia', '', [Validators.required], 6),
      ], ['Calcular'], 'Calcular KM'), this.formData
    )
  }

  formData = async (form) => {
    let newForm = form;
    const params = {};
    if (this.codigoPostal) {
      params["cp"] = this.codigoPostal;
      this.codigoPostal = null;
    }

    const Res = await Http.get(`zona/calcular-zona/form?${objectAsParams(params)}`);
    if (!Res.error) {
      const { sucursales = [], colonias = [] } = Res.data;
      newForm = Form.FieldOptions(newForm, 'id_sucursal', sucursales, 'id', 'sucursal');
      newForm = Form.FieldOptions(newForm, 'id_colonia', colonias, 'id', 'colonia');
    }
    newForm = Form.ValueChange(newForm, {
      codigo_postal: async (field) => { field.Value.length > 4 && this.fieldChange(field) },
    })
    return newForm;
  }

  fieldChange = async (field, variable) => {
    this.codigoPostal = field.Value;
    this.setState({ FormData: await this.formData(this.state.FormData) })
  }

  onSubmit = async (i, vals) => {
    vals.id = this.props.match.params.id;
    this.setState({ loading: true });
    var Res = await Http.post(`${this.config.saveUrl}`, vals);
    if (!Res.error) {
      const { distancia, zona } = Res.data;
      this.setState({ loading: false, sbMsg: `Kilometros calculados: ${distancia}, Zona: ${zona}`, sbOpen: true });
    } else {
      this.setState({ loading: false, sbMsg: `Error al calcular`, sbOpen: true });
    }
  }

  render() {
    return (
      <div>
        <this.FormRender />
      </div>
    )
  }
}

export default withRouter(CalcularKm)
